module.exports = __webpack_public_path__ + "media/images/games/k2gender/egg-7d4c81c55b5d9b65180e7608a967cada.png";